import { Sizes } from 'src/design-system/style-types';
import { Box } from '../Box';
import { Text } from '../Text';

type Props = {
  numberText: string | number;
  postfix?: string;
  useEllipsis?: boolean;
  size?: Sizes;
};

export const LegendNumber = ({ numberText, postfix, useEllipsis = true, size = '3xl' }: Props) => {
  return (
    <Box wrap="nowrap" a="flex-end" w="100px">
      <Text weight="light" ellipsis={useEllipsis} size={size}>
        {numberText}
      </Text>
      <Text marginLeft="xs" marginBottom={size === '3xl' ? 'xs' : undefined} weight="normal" color="grey" size="sm">
        {postfix}
      </Text>
    </Box>
  );
};
